<template>
  <div class="main-custom">
    <b-loading :active="isLoading" />
    <Header />
    <div id="printable" class="container">
      <h1 class="title ml-30 my-20 has-text-blue-oil">
        {{ App.Version.TITLE_PAGE }}
      </h1>

      <div class="level mx-30 has-text-left header-label">
        <span></span>
        <div class="level-left icons-margin p-5 mr-10">
          <span class="mx-10 has-text-blue-oil is-align-self-center">
            {{ General.PARTICIPATE }}:
          </span>
          <ShareNetwork
            network="facebook"
            :url="currentUrl"
            :title="App.Version.TITLE_PAGE"
            :description="App.Version.VIEW_HISTORY"
            hashtags="GovCe, GovBr, Suite"
          >
            <img :src="facebookIcon" class="icon" alt="" />
          </ShareNetwork>
          <ShareNetwork
            network="Twitter"
            :url="currentUrl"
            :title="App.Version.TITLE_PAGE"
            hashtags="GovCe, GovBr, Suite"
          >
            <img :src="twitterIcon" class="icon" alt="" />
          </ShareNetwork>
          <ShareNetwork
            network="WhatsApp"
            :url="currentUrl"
            :title="App.Version.TITLE_PAGE"
            hashtags="GovCe, GovBr, Suite"
          >
            <img :src="whatsappIcon" class="icon" alt="" />
          </ShareNetwork>
          <a
            v-clipboard:copy="currentUrl"
            v-clipboard:success="handleCopyStatus"
          >
            <img :src="linkVariantIcon" class="icon" alt="" />
          </a>
          <span class="is-size-5 has-text-weight-normal mx-10 has-text-blue-oil"
            >|</span
          >
          <b-icon
            icon="printer"
            class="is-clickable"
            type="is-blue-oil"
            @click.native="printScreen"
          />
        </div>
      </div>

      <section class="mx-30">
        <template v-if="versions.list.length">
          <div
            v-for="(version, index) in versions.list"
            :key="index"
            class="version mb-15"
          >
            <h1 class="version-title is-size-5">
              <span
                >{{ App.ModalPartnership.VERSION }} {{ version.version }}</span
              >
            </h1>
            <span class="is-size-5 has-text-weight-normal">
              {{ version.description }}
            </span>
            <p class="mt-5">
              <a
                class="has-text-weight-semibold has-text-primary is-align-self-center"
                @click="openDetail(version)"
              >
                <b-icon class="custom-height" icon="magnify-plus-outline" />
                <span class="is-size-5">{{ App.Version.VIEW_ALL }}</span>
              </a>
            </p>
            <hr v-if="index != versions.length - 1" />
          </div>

          <div class="pagination-custom">
            <span class="has-text-semibold is-align-self-center">{{
              getPaginationDetails
            }}</span>

            <b-pagination
              :total="versions.count"
              :perPage="perPage"
              :current.sync="currentPage"
              rangeBefore="1"
              rangeAfter="1"
              order="is-centered"
              rounded
              :iconPrev="prevIcon"
              :iconNext="nextIcon"
              :aria-next-label="General.NEXT_PAGE"
              :aria-previous-label="General.PREVIOUS_PAGE"
              :aria-page-label="General.PAGE"
              :aria-current-label="General.CURRENT_PAGE"
            />
          </div>
        </template>
        <template v-else>
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                {{ App.Version.NO_VERSIONS.toUpperCase() }}
              </p>
            </div>
          </section>
        </template>
      </section>
    </div>
    <Footer :isReduced="true" />
  </div>
</template>

<script>
import Header from "@/layout/Header";
import Footer from "@/layout/Footer";
import ModalVersionDetail from "@/views/App/ModalVersionDetail";
import facebookIcon from "@/assets/images/facebook.svg";
import twitterIcon from "@/assets/images/twitter.svg";
import whatsappIcon from "@/assets/images/whatsapp.svg";
import linkVariantIcon from "@/assets/images/linkVariant.svg";

import { General, App } from "@/utils/constants";
import { mapActions, mapGetters } from "vuex";
import { formatPagination } from "@/utils/transformers";

export default {
  name: "Versions",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      General,
      App,
      isLoading: false,
      currentPage: 1,
      perPage: 5,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      facebookIcon,
      twitterIcon,
      whatsappIcon,
      linkVariantIcon
    };
  },
  computed: {
    ...mapGetters({
      versions: "getVersion"
    }),
    currentUrl() {
      return window.location.href;
    },
    getPaginationDetails() {
      return formatPagination(this.versions, this.currentPage, this.perPage);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.requestVersion({
          paginator_count: this.perPage,
          page: this.currentPage
        });
      }
    }
  },
  async beforeMount() {
    this.isLoading = true;
    await this.requestVersion({
      paginator_count: this.perPage,
      page: this.page
    });
    this.isLoading = false;
  },
  methods: {
    ...mapActions(["requestVersion"]),
    printScreen() {
      const printableHtml = document.getElementById("printable").innerHTML;

      let printableStyles = "";
      [...document.querySelectorAll("link[rel='stylesheet'], style")].forEach(
        element => {
          printableStyles += element.outerHTML;
        }
      );

      const printableWindow = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      printableWindow.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${printableStyles}
        </head>
        <body>
          ${printableHtml}
        </body>
      </html>`);

      printableWindow.document.close();
      printableWindow.focus();
      printableWindow.print();
    },

    openDetail(version) {
      version = {
        ...version,
        old: true
      };
      this.$buefy.modal.open({
        parent: this,
        component: ModalVersionDetail,
        props: {
          version
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    handleCopyStatus() {
      this.$buefy.toast.open({
        message: "URL copiada",
        type: "is-green-dark"
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables.scss";

.container {
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 90%;
  padding: 15px 0;
  min-height: 400px;
}
.header-label {
  background-color: var(--app-background-color);
  align-items: center;
  border-radius: 5px;
}
.custom-height {
  height: auto;
}
.icon {
  margin-right: 0.75rem;
}

@media print {
  .no-print {
    display: none;
  }

  @page {
    margin: 0;
  }
}
.version {
  &-title {
    font-weight: 600;
    margin-bottom: 10px;
    color: $blue-oil;
  }
  hr {
    border: 1px solid $border-color;
  }
}
.pagination-custom {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  padding: 10px 0;
}
</style>
